export const CORPORATE_PAYMENT_ERROR = '获取对公支付信息失败，请重试';
export const CORPORATE_REQUEST_TIMEOUT_MS = 30_000;
